import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const notificationTriggerTypesAdapter = getAdapter();

const notificationTriggerTypesSlice = createSlice({
  name: 'notificationTriggerTypes',
  initialState: notificationTriggerTypesAdapter.getInitialState(),
  reducers: {
    setNotificationTriggerTypes: (state, { payload: { notificationTriggerTypes } }) => {
      notificationTriggerTypesAdapter.setAll(state, notificationTriggerTypes);
    },
  },
});

const selectors = notificationTriggerTypesAdapter.getSelectors(({ notificationTriggerTypes }) => notificationTriggerTypes);

export const getNotificationTriggerTypes = (state) => selectors.selectAll(state);

export const {
  setNotificationTriggerTypes,
} = notificationTriggerTypesSlice.actions;

export default notificationTriggerTypesSlice.reducer;
